import * as React from 'react';
import { RouteComponentProps, withRouter, Link, NavLink, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import bindAllOfThis from 'src/utils/BindThisHelper';
import { PageProps } from "src/models/common/ComponentProps";
import { Row, Col, Icon, Spin, Table, Input, Button } from "antd";
import ReportApiController from "src/api/ReportApiController";

import { ReduxStoreModel } from "src/redux/ReduxModel";
import { UserState } from "src/redux/UserReducer";
import { withLocalize, LocalizeContextProps, Translate } from "react-localize-redux";
import SuperintendentReportResponseDTO from "src/models/report/SuperintendentReportResponseDTO";
import DataTable, { DataTableButton } from 'src/components/common/DataTable';
import SuperintendentReportGradeDTO from 'src/models/report/SuperintendentReportGradeDTO';
import { ColumnProps } from 'antd/lib/table';
import Column from 'antd/lib/table/Column';
import Routes from 'src/core/Routes';

interface RouteParams {
    schoolId: string;
}

interface SuperintendentReportProps extends PageProps<RouteParams>, LocalizeContextProps {
    // Redux
    User: UserState;
}

interface SuperintendentReportState {
    schools: SuperintendentReportResponseDTO[];
    isLoading: boolean;
}

class SuperintendentReport extends React.Component<SuperintendentReportProps, SuperintendentReportState> {
    constructor(props: SuperintendentReportProps) {
        super(props);
        bindAllOfThis(this, SuperintendentReport.prototype);

        this.state = {
            schools: [],
            isLoading: true,
        };
    }

    componentDidMount(): void {
        this.deriveStateFromProps(this.props);
    }

    componentWillReceiveProps(nextProps: SuperintendentReportProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage) {
            this.deriveStateFromProps(nextProps);
        }
    }

    deriveStateFromProps(props: SuperintendentReportProps) {
        ReportApiController.getSuperintendentReport().then(response => {
            if (response.ok) {
                this.setState({
                    schools: response.data,
                    isLoading: false
                });
            }
        });
    }

    expandedRowRender = (record: SuperintendentReportResponseDTO, index: number, indent: number, expanded: boolean): React.ReactNode => {
        const columns: ColumnProps<SuperintendentReportGradeDTO>[] = [
              {
                  dataIndex: "grade",
                  align: "center"
              },
              {
                  dataIndex: "percentComplete",
                  align: "center"
              }
        ];

        return (
            <Table
                size="small"
                style={{maxWidth: 300}}
                rowKey = "id"
                columns={columns}
                dataSource={record.grades}
                pagination={false}
                showHeader={false}
            />
        );
    }

    render() {
        if (this.state.isLoading) {
            return <div className="teacher-reports">
                <h2><Translate id="report.superintendent.headerText" /></h2>
                <p><Translate id="report.classroom.loadingText" /></p>
                <Spin />
            </div>;
        }
        return <div className="teacher-reports">
            <DataTable
                data={this.state.schools}
                className="report-container-new"
                tableProps={{
                    rowKey: "schoolId",
                    loading: this.state.isLoading,
                    expandedRowRender: this.expandedRowRender
                }}
                columns={[
                    DataTable.StandardColumns.Text("report.superintendent.header.schoolName", "school"),
                    DataTable.StandardColumns.Text("report.principal.header.percent", "percentComplete"),
                ]}
                buttonBar={[
                    new DataTableButton("dataTable.export", () => window.location.href = "/" + ReportApiController.RouteExportSuperintendentReport())
                ]}
            />
        </div>;
    }
}


function mapStateToProps(state: ReduxStoreModel) {
    return {
        User: state.User
    };
}

export default connect(mapStateToProps)(withLocalize(SuperintendentReport));



// WEBPACK FOOTER //
// ./src/pages/admin/SuperintendentReport.tsx